import {mapState} from 'vuex'

export default {
    computed: {
        ...mapState(['health_insurance_funds'])
    },

    mounted() {
        if(!this.health_insurance_funds.length) {
            this.$store.dispatch('fetchHealthInsuranceFunds');
        }
    }

}
